// import { IS_LOADED } from './type';
import axios from 'axios';

export const fetchData = data => dispatch => {
    axios.post('/api/assistant/fetchData', data)
    .then(res => console.log({res}))
    .catch(err => console.log({err}));
};